import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actions } from 'react-redux-form';
import { bindActionCreators } from 'redux';

import DetailContainer from "../Layout/details/DetailsLayout.component";
import ModalContainer from "../modal/modal-container/modal-container.component";
import ArticleDetails from "../../external/recharge/article-catalogue/modal-form/details/form/article-catalogue-details.component";
import ArticleHistory from "../../external/recharge/article-catalogue/modal-form/history/article-history.component";
import { Selected_Index } from "../../../constants/external-constants";
import { articleCatalogueActions } from "../../../store/external/recharge-reducer/article-catalogue-reducer/article-catalogue.reducer";
import { articleCatalogueMilestoneActions } from "../../../store/external/recharge-reducer/article-catalogue-milestone.reducer/article-catalogue-milestone.reducer";
import { NoSubscription } from "../../external/dashboard/no-subscription/no-subscription.component";
import { TRANSLATIONS as translation } from "../../../utils/constant.utils";

class ArticleModal extends Component {

    constructor(props) {
        super(props);
        this.handleTabIcon = this.handleTabIcon.bind(this)
        this.state = {
            displaySearch: false,
            detailsView: false,
            employeeId: 0,
            userId: 0,
            showModal: false,
            showModalForm: false,
            isNew: false,
            activeTab: Selected_Index.i_Zero,
            contentIndex: Selected_Index.i_Zero,
            selectedCircuit: undefined,
            circuitId: 0,
            articleId: 0,
            createNew: false,
            viewDetailPage: false,
            headerTitle: "ArticleCatalogue",
            activeTabIcon: Selected_Index.i_Zero,
            buttonName: "Add Component",
            showSecondarybtn: false,
            showNotif: false,
            haveError: false,
            modalMessage: '',
            primaryTooltipLabel: "",
            secondaryTooltipLabel: "",
            articleComponent: [],
            isButtonDisabled: false, // <-- New state to control button
            isArticleAlreadyExist: false,
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            confirmationModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            tabList: [
                {
                    type: "article",
                    title: "Article",
                    icon: "file-lines",
                    color: "font-blue",
                    isActive: true,
                    disabled: false
                },
                {
                    type: "component",
                    title: "Component",
                    icon: "layer-group",
                    color: "font-purple",
                    isActive: false,
                    disabled: false
                },
                {
                    type: "formula",
                    title: "Formula",
                    icon: "calculator-simple",
                    color: "font-green",
                    isActive: false,
                    disabled: false
                }
            ]
        }
    }

    componentDidMount() {
        this.props.getArticleCatalogue();
        this.props.getArticleCatalogueDropdownList();
        this.props.getArticleCatalogueMilestoneDetails(this.props.articleId).then(() => {
            if (this.props.isViewing) {
                if (this.props.articleCatalogueMilestoneForm.priceCalculationId) {
                    const disableTabIndex = [1, 2];
                    this.setState((prevState) => ({
                        tabList: prevState.tabList.map((tab, i) => (
                            { ...tab, disabled: disableTabIndex.includes(i) }
                        ))
                    }));
                }
            }
        })
    }

    componentWillUnmount() {
        this.props.setDefaultArticleCatalogue();
    }


    loading = () => {
        return (
            <NoSubscription />
        );
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props.translation;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    handleCloseForm = () => {
        this.setState({
            viewDetailPage: false,
            articleId: 0,
            isArticleAlreadyExist: false,
            createNew: false
        }, this.changeHeaderTitle);
    };

    handleSelectedIndex = (index) => {
        this.setState({ contentIndex: index });
    };

    handleCreateNewAction = () => {
        const disableTabIndex = [1, 2];
        this.props.resetArticleCatalogueMilestoneForm();
        this.setState((prevState) => ({
            showModal: true,
            isNew: true,
            createNew: true,
            activeTabIcon: Selected_Index.i_Zero,
            tabList: prevState.tabList.map((tab, i) => ({
                ...tab,
                disabled: disableTabIndex.includes(i)
            }))
        }));
        this.handleTabIcon(parseInt(Selected_Index.i_Zero))
    }

    changeHeaderTitle = () => {
        this.setState({
            headerTitle: this.state.viewDetailPage || this.state.createNew ? "ArticleCatalogue" : ""
        });
    };

    handleCreateNewConf(buttonType) {
        if (buttonType === "ok") {
            this.setState({
                showModalForm: true,
                showModal: false,
                isNew: true,
                viewDetailPage: true,
                buttonName: "Save Changes",
                primaryTooltipLabel: "save_article_info",
                showSecondarybtn: false,
                articleComponent: [],
            })
        } else {
            this.setState({
                showModal: false,
                viewDetailPage: true
            })
        }
    };

    handleCloseFormModal = () => {
        this.setState({
            showModalForm: false,
            contentIndex: Selected_Index.i_Zero,
            isArticleAlreadyExist: false,
            isNew: false,
            articleId: 0,
            activeTabIcon: Selected_Index.i_Zero
        });
        this.props.handleClose(false);
    };

    onChangeExtractAlertMsg = (val) => {
        this.setState({ extractAlertMsg: val });
    };

    handleCreateNew = (buttonType) => {
        if (buttonType === "ok") {
            this.setState({
                articleId: 0,
                createNew: !this.state.createNew,
                showModal: false,
                buttonName: "Save Changes",
                showSecondarybtn: false,
                articleComponent: [],
            }, this.changeHeaderTitle);
        } else {
            this.setState({ showModal: false })
        }

    };

    handleTabIcon = (index) => {
        this.setState({ activeTabIcon: index })

        this.setState((prevState) => ({
            activeTabIcon: index,
            tabList: prevState.tabList.map((tab, i) => ({
                ...tab,
                isActive: i === index
            }))
        }));

        switch (parseInt(index)) {
            case 0:
                return this.setState({
                    buttonName: this.state.articleId !== 0 ? "Save Changes" :
                        (parseInt(this.props.articleCatalogueMilestoneForm.priceCalculationId === 1) ? "Save Changes" : "Add Component"),
                    showSecondarybtn: false,
                    primaryTooltipLabel: (parseInt(this.state.articleId) !== 0) ? "save_article_info" : "add_component",
                });
            case 1:
                return this.setState({
                    buttonName: this.state.articleId !== 0 ? "Update Formula" : "Add Formula",
                    showSecondarybtn: this.state.articleId !== 0 ? false : true,
                    primaryTooltipLabel: "add_formula",
                    secondaryTooltipLabel: "go_back_article"
                });
            case 2:
                return this.setState({
                    buttonName: "Save Changes",
                    showSecondarybtn: true,
                    primaryTooltipLabel: "save_article_details",
                    secondaryTooltipLabel: "go_back_component"
                });
            default:
                return null
        }

    };

    handlePrimaryBtn = async (debitorId, validate = 1) => {
        const { buttonName, activeTabIcon } = this.state;
        const { articleCatalogueMilestoneForm, getArticleCatalogue } = this.props;
        const { PageNumber } = this.props.articleCatalogue?.articleCatalogueItems?.Pagination;
        if (buttonName === "Add Component") {
            this.handleTabIcon(parseInt(Selected_Index.i_One));
            this.setState((prevState) => ({
                tabList: prevState.tabList.map((tab) => ({ ...tab, disabled: false })),
            }));
        } else if (buttonName === "Add Formula" || buttonName === "Update Formula") {
            this.handleTabIcon(parseInt(Selected_Index.i_Two));
        } else if (buttonName === "Save Changes") {
            this.setState({
                isSaving: true,
                isArticleAlreadyExist: false
            });
            var result = await this.props.saveArticleCatalogueForm(articleCatalogueMilestoneForm.articleId, validate);
            this.setState({
                isSaving: false
            });

            if (result.success) {
                if (result.isValid) {
                    const confirmMessage = "Are you sure you want to save?";
                    const modalTitle = this.toLocaleLanguage("call_save", false);
                    var confirmAction = () => this.handlePrimaryBtn(articleCatalogueMilestoneForm.articleId, 0)
                    this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                    return;
                }
                else {
                    this.toggleSaveModal(false);
                    getArticleCatalogue(PageNumber);
                    if (result.message === "Article has been created.") {
                        this.toggleSaveNotif(true, this.toLocaleLanguage("success_modal_title", false), result.message);
                        this.handleCloseFormModal();
                    }
                    else if (result.message === "has been updated.") {
                        const tabNameMap = {
                            0: "Article",
                            2: "Component and Formula"
                        };

                        const tabName = tabNameMap[activeTabIcon] || "Article";
                        const finalMessage = `${tabName} ${result.message}`;
                        this.toggleSaveNotif(true, this.toLocaleLanguage("success_modal_title", false), finalMessage);
                        this.props.getArticleCatalogueMilestoneDetails(this.state.articleId);
                        if (tabName === "Component and Formula") {
                            this.handleDisableButton(true);
                        }

                    }
                    return;
                }
            }
            else {
                if (result.message === "Modifying Article required field will create a new Article. Would you like to continue?") {
                    const modalTitle = this.toLocaleLanguage("modal_confirmation_title", false);
                    confirmAction = () => this.handleCreateNewModifyAction()
                    this.toggleSaveModal(true, modalTitle, result.message, confirmAction)
                    return;

                }
                else if (result.message === "Article already exist.") {
                    this.toggleSaveModal(false);
                    this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);
                    this.setState({
                        isArticleAlreadyExist: true
                    });
                    return;
                }
                else {
                    this.toggleSaveModal(false);
                    this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message !== undefined ? result.message : this.toLocaleLanguage("article_not_saved_error", false));
                    return;
                }
            }
        }
    };

    handleDisableButton = (isDisabled, priceCalculation) => {
        const { buttonName, activeTabIcon } = this.state;
        if (this.state.articleId === 0) {
            if (priceCalculation === '1') {
                const disableTabIndex = [1, 2];
                this.props.resetArticleComponentMilestoneForm();
                this.setState((prevState) => ({
                    activeTabIcon: Selected_Index.i_Zero,
                    tabList: prevState.tabList.map((tab, i) => ({
                        ...tab,
                        disabled: disableTabIndex.includes(i)
                    }))
                }));
                return this.setState({ buttonName: "Save Changes", showSecondarybtn: false, primaryTooltipLabel: "save_article_info", secondaryTooltipLabel: "" });
            }
            else if (priceCalculation === '2') {
                return this.setState({ buttonName: "Add Component", showSecondarybtn: false, primaryTooltipLabel: "add_component", secondaryTooltipLabel: "" });
            }
        }
        this.setState({ isButtonDisabled: isDisabled });
    };

    handleDisabledTab = (index) => {
        const disableTabIndex = [1, 2];
        const selectedIndex = parseInt(index);
        this.setState((prevState) => ({
            tabList: prevState.tabList.map((tab, i) => (
                i === selectedIndex ? { ...tab, disabled: disableTabIndex.includes(i) } : tab
            ))
        }));

    };

    handleSecondary = () => {
        this.handleTabIcon(this.state.activeTabIcon - 1);
    };


    handleCloseNotif = () => {
        this.setState({ showNotif: false });
    };

    handleCreateNewModifyAction = () => {
        const disableTabIndex = [1, 2];
        this.props.resetArticleComponentMilestoneForm();
        this.setState((prevState) => ({
            articleId: 0,
            isNew: true,
            createNew: true,
            articleComponent: [],
            activeTabIcon: Selected_Index.i_Zero,
            tabList: prevState.tabList.map((tab, i) => ({
                ...tab,
                disabled: disableTabIndex.includes(i)
            }))
        }));
        this.handleTabIcon(parseInt(Selected_Index.i_Zero))
        this.props.FormChange("articleCatalogueMilestoneForm.articleId", 0);
        this.setState({
            buttonName: (this.props.articleCatalogueMilestoneForm.priceCalculationId === 1 || this.props.articleCatalogueMilestoneForm.priceCalculationId === '1') ? "Save Changes" : "Add Component",
            showSecondarybtn: false,
        });

        this.toggleSaveModal(false);
    }

    render() {
        const { showModalForm, contentIndex, activeTabIcon, activeTab, tabList } = this.state;
        return (
            <>
                <ModalContainer
                    title="article_info"
                    show={this.props.showModalForm}
                    handleModal={this.handleCloseFormModal}
                    hideBtn={contentIndex === Selected_Index.i_One}
                    saveDetails={this.handlePrimaryBtn}
                    secondaryBtnFc={this.handleSecondary}
                    customClass="cost-allocation-details__modal modal-form__container article_detail__container"
                    disabled={false}
                    isReadAndWrite={''}
                    buttonName={''}
                    showSecondarybtn={''}
                    primaryBtnTooltip={''}
                    secondaryBtnTooltip={''}
                >

                    <div className="data-table">
                        <DetailContainer
                            renderTabContent={this.handleSelectedIndex}
                            urlIndex={activeTab}
                            tabListIcon={tabList}
                            onhandleIconClick={this.props.articleId !== 0 ? this.handleTabIcon : ''}
                            hideTabIcon={contentIndex === Selected_Index.i_One}
                            listTab={[
                                {
                                    "id": Selected_Index.i_Zero,
                                    "label": "Details",
                                    "hidden": false
                                },
                                {
                                    "id": Selected_Index.i_One,
                                    "label": "History",
                                    "hidden": false,
                                    "disable": false
                                },

                            ]}
                        >

                            {contentIndex === Selected_Index.i_Zero &&
                                <ArticleDetails
                                activeTabIcon={activeTabIcon}
                                articleId={this.props.articleId}
                                onDisabledTab={this.handleDisabledTab.bind(this)}
                                isReadOnly={''}
                                isReadAndExtractOnly={''}
                                isReadAndWrite={''}
                                //onDisableButton={this.handleDisableButton.bind(this)}
                                articleComponent={this.state.articleComponent || []}
                                isArticleAlreadyExist={this.state.isArticleAlreadyExist}
                                articleCatalogueMilestone={this.props.articleCatalogueMilestone}
                                isViewing={this.props.isViewing}
                                />
                            }   
                            {contentIndex === Selected_Index.i_One &&
                                <ArticleHistory
                                    articleId={this.props.articleId}
                                    isReadOnly={''}
                                    isReadAndExtractOnly={''}
                                    isReadAndWrite={''}
                                    isViewing={this.props.isViewing}
                                />
                            }

                        </DetailContainer>
                    </div>

                </ModalContainer>
            </>
        )
    }

}

export default withRouter(connect(
    state => {
        const { articleCatalogue,
            translation,
            articleCatalogueMilestone,
            form: { forms: { articleCatalogueMilestoneForm: { $form } } }
        } = state;
        const { articleCatalogueMilestoneForm } = state.form;
        return {
            translation
            , articleCatalogue
            , articleCatalogueMilestone
            , articleCatalogueMilestoneForm
            , $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, articleCatalogueActions, articleCatalogueMilestoneActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(ArticleModal));